export default __webpack_public_path__ + "static/media/workBanner.1bc2e91a.png";